import { Tab, Tabs } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { useUserApi } from '../services/api/useUser.api';
import { Role } from '../types/enums/Role.enum';

function SettingsLayout() {
  const location = useLocation();
  const navigate = useNavigate();

  const { getUserInfo } = useUserApi();

  const { data: user } = useQuery({
    queryKey: ['userInfo'],
    queryFn: getUserInfo,
  });

  const tabs = [
    ...([Role.SUPER_ADMIN, Role.ADMIN].includes(user?.role?.id as Role)
      ? [{ label: 'Team', path: '/settings/team' }]
      : []),
  ];

  const currentTab = tabs.findIndex((tab) => tab.path === location.pathname);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    navigate(tabs[newValue].path);
  };

  return (
    <>
      <Tabs
        sx={{ background: '#fff', borderBottom: 1.2, borderColor: 'divider', marginBottom: 6 }}
        value={currentTab !== -1 ? currentTab : false}
        onChange={handleTabChange}
      >
        {tabs.map((tab, index) => (
          <Tab sx={{ textTransform: 'none' }} key={index} label={tab.label} />
        ))}
      </Tabs>
      <Outlet />
    </>
  );
}

export default SettingsLayout;
